<template>
    <div>
        <div
            class="modal fade quote-no-modal"
            id="noQuoteModal"
            tabindex="-1"
            aria-labelledby="noQuoteModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="noQuoteModalLabel">Select no quote reason</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label quote-no-modal__label">Reason</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <span class="select">
                                        <select
                                            :value="qNoQuoteReason"
                                            @input="handleSelectValue($event)"
                                            id="q_no_quote_reason"
                                            class="quote-no-modal__select"
                                            :class="{ 'is-invalid': reasonError }"
                                        >
                                            <option value="" disabled selected></option>
                                            <option
                                                v-for="(noQuoteReason, index) in noQuoteReasonsItems"
                                                :key="index"
                                                :value="noQuoteReason"
                                            >
                                                {{ noQuoteReason }}
                                            </option>
                                        </select>
                                    </span>
                                    <p v-if="reasonError" class="help quote-no-modal__error">
                                        Reason cannot be empty.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="buttons is-right quote-no-modal__actions">
                            <button
                                type="button"
                                class="quote-no-modal__button quote-no-modal__button--secondary"
                                @click="closeModal"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                class="quote-no-modal__button quote-no-modal__button--success"
                                @click="submitReason()"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<style scoped>
    .quote-no-modal :deep(.modal-content) {
        background: var(--color-surface-canvas);
        color: var(--color-text-primary);
        border: 1px solid var(--color-border-default);
        box-shadow: var(--shadow-lg);
    }

    .quote-no-modal :deep(.modal-header),
    .quote-no-modal :deep(.modal-body),
    .quote-no-modal :deep(.modal-footer) {
        background: var(--color-surface-canvas);
        color: var(--color-text-primary);
        border-color: var(--color-border-muted);
    }

    .quote-no-modal :deep(.modal-title),
    .quote-no-modal__label {
        color: var(--color-text-primary);
        font-weight: 700;
    }

    .quote-no-modal :deep(.btn-close) {
        opacity: 0.8;
    }

    html[data-theme='dark'] .quote-no-modal :deep(.btn-close) {
        filter: invert(1) grayscale(1);
    }

    .quote-no-modal .select,
    .quote-no-modal .field-body,
    .quote-no-modal .field {
        width: 100%;
    }

    .quote-no-modal__select {
        width: 100%;
        min-height: 2.5rem;
        padding: 0.5rem 0.75rem;
        background: var(--color-surface-subtle);
        color: var(--color-text-primary);
        border: 1px solid var(--color-border-default);
        border-radius: var(--radius-sm);
    }

    .quote-no-modal__select:focus {
        border-color: var(--color-border-accent-strong);
        box-shadow: var(--shadow-focus-brand);
        outline: none;
    }

    .quote-no-modal__select.is-invalid {
        border-color: var(--color-border-accent-strong) !important;
        box-shadow: var(--shadow-focus-brand) !important;
    }

    .quote-no-modal__error {
        margin-top: 0.25rem;
        color: var(--color-brand-primary-strong);
        font-weight: 600;
    }

    .quote-no-modal__actions {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        gap: 0.75rem;
    }

    .quote-no-modal .quote-no-modal__button {
        min-width: 7rem;
        padding: 0.625rem 1.125rem;
        border-radius: var(--radius-sm);
        border: 1px solid transparent;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        line-height: 1.2;
        transition:
            background-color 0.15s ease,
            border-color 0.15s ease,
            color 0.15s ease,
            transform 0.15s ease;
    }

    .quote-no-modal .quote-no-modal__button:hover {
        transform: translateY(-1px);
    }

    .quote-no-modal .quote-no-modal__button--secondary {
        background: var(--color-surface-subtle);
        color: var(--color-text-primary);
        border-color: var(--color-border-default);
    }

    .quote-no-modal .quote-no-modal__button--secondary:hover,
    .quote-no-modal .quote-no-modal__button--secondary:focus {
        border-color: var(--color-border-accent-strong);
        color: var(--color-text-primary);
    }

    .quote-no-modal .quote-no-modal__button--success {
        background: var(--color-state-success);
        color: var(--color-text-inverse);
        border-color: var(--color-state-success);
    }

    .quote-no-modal .quote-no-modal__button--success:hover,
    .quote-no-modal .quote-no-modal__button--success:focus {
        background: var(--color-state-success-strong);
        border-color: var(--color-state-success-strong);
        color: var(--color-text-inverse);
    }
</style>

<script>
import { Modal } from 'bootstrap';
import { useDropdownsStore } from '@/stores/dropdownsStore'
import { mapStores } from 'pinia'

export default {
    name: 'NoQuoteModal',
    data() {
        return {
            reasonError: false
        }
    },
    computed: {
        ...mapStores(useDropdownsStore),
        noQuoteReasonsItems: {
                get() {
                    return this.dropdownsStore.no_quote_reasons
                },
        },
    },
    props: {
        qNoQuoteReason: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {
        closeModal() {
            const modalElement = document.getElementById('noQuoteModal');
            if (modalElement) {
                const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
                modal.hide();
            }
        },
        submitReason() {
            if (this.qNoQuoteReason === '') {
                this.reasonError = true;
                return;
            }
            this.reasonError = false;
            this.$emit('submitReason', this.qNoQuoteReason)
        },
        handleSelectValue($event) {
            
            this.$emit('update:qNoQuoteReason', $event.target.value)
            if ($event.target.value !== '') {
                this.reasonError = false;
            }

        }
    }
}
</script>
